import { render, staticRenderFns } from "./entrustOrderDetail.vue?vue&type=template&id=51986c84&scoped=true"
import script from "./entrustOrderDetail.vue?vue&type=script&lang=js"
export * from "./entrustOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./entrustOrderDetail.vue?vue&type=style&index=0&id=51986c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51986c84",
  null
  
)

export default component.exports